import { createContext } from 'react';

export const PacketContext = createContext({});
export const PacketModalsContext = createContext({});
export const ToolbarContext = createContext({});
export const TemplateContext = createContext({});
